/**
 * @file index.tsx
 *
 * @fileoverview Renders link referring to the font styles file.
 */
import localFont from 'next/font/local';
const roboto = localFont({
  src: [
    {
      path: './../../../../../public/fonts/woff2/Roboto-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/Roboto-semibold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/Roboto-bold.woff2',
      weight: '900',
      style: 'regular',
    },
  ],
});

export const NextFontSlot = ({ children }) => (
  <div className={roboto.className}>
    {children}
    <style jsx global>{`
      :root {
        --font-family-body: ${roboto.style.fontFamily};
        --font-family-headings: ${roboto.style.fontFamily};
      }
    `}</style>
  </div>
);
